var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('TransactionsDetailedHeader',{style:({ 'background-image': "url(/static/images/svgs/group-4.svg)",'background-repeat': 'no-repeat',
  'background-position': 'bottom right' }),attrs:{"h1text":'Complete KYC',"ptext":'Complete KYC to avail more benefits'}}),_vm._v(" "),(_vm.user.user_properties.dmi>0)?_c('p',{staticClass:"text-center",staticStyle:{"padding":"30px"}},[_vm._v("\n    You have already completed your KYC\n  ")]):_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-147bbe9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/DMIForm/component.html
// module id = null
// module chunks = 